import { z } from 'zod'

export const CurrentStats = z.object({
  messages_in: z.number(),
  messages_out: z.number(),
  spam_blocked: z.number()
})

export type CurrentStats = z.infer<typeof CurrentStats>

export const HistoryPoint = z.object({
  timestamp: z.string(),
  messages_in: z.number(),
  messages_out: z.number()
})

export type HistoryPoint = z.infer<typeof HistoryPoint>

export const MailStats = z.object({
  period: z.enum(['day', 'week', 'month']),
  current: CurrentStats,
  history: z.array(HistoryPoint).optional()
})

export type MailStats = z.infer<typeof MailStats>
